import React, { useEffect, useState } from 'react'
import { MuiButton } from "../../ui/MaterialUIComponents";
import { MuiTypography } from '../../ui';
import { updateUserProfile } from '../../../store/userProfile/UserProfileActions';
import { editSchoolInformation } from '../../../store/schoolInformation/SchoolInformationActions';
import { APIDirectory } from '../../../rest';
import theme from '../../../assests/theme'
import {Logout} from 'react-cognito';
const MakeOwner =(props)=>{

    const [transferOwnerId, setTransferOwnerId] = useState();
    const [isOwner, setIsOwner] = useState(false);
    const [isRevoked,setIsRevoked] = useState(false);
    const [rerendeFlag, setRerender] = useState(false);


    useEffect(()=>{        
        let url = window.location.href; 
        let arr = url.split('/');
        let transferOwnerId = arr[arr.length -1];
        setTransferOwnerId(transferOwnerId);
        async function isTransferOwnerAlreadyOwner(){
         let result = await  this.props.getOwners(transferOwnerId)
         if(result.data == "OWNER"){
             setIsOwner(true);
         }
         if(result.data == "REVOKED"){
            setIsRevoked(true);
         }
        }
        isTransferOwnerAlreadyOwner();
    }, [])

    const isAcceptEnabled = async () =>{
        let ownerFlag = isOwner; 
        let revokedFlag = isRevoked;
        let flag = true;
        let result = this.props.getOwners(transferOwnerId)
            if(result.data == "OWNER"){
                // setIsOwner(true);
                ownerFlag = true;
                flag = false;
            }
            else if (result.data == "REVOKED"){
                // setIsRevoked(true);
                revokedFlag = true;
                flag = false;
            }

            setIsOwner(ownerFlag);
            setIsRevoked(revokedFlag);
            return flag;
    }


    const onClickOfAccept = async ()=>{
        let url = window.location.href; 
        let arr = url.split('/');
        let transferOwnerId = arr[arr.length -1];
        setTransferOwnerId(transferOwnerId);
        let response;
        
        if(isAcceptEnabled()){
            response = this.props.acceptOwnerInvite(transferOwnerId)
        }
        setRerender(!rerendeFlag);
        props.user.signOut();    
        // window.location.href = '/'

    }

    
    return(
       <Logout>
        <div style={{margin: '10vh'}}>
            <h1>Owner Invite Page</h1>
            
            {
            isOwner == false  && isRevoked == false 
                ?
                        <MuiButton onClick={onClickOfAccept}  style={theme.primaryButtonStyle}>ACCEPT</MuiButton>
                :
                (
                   (isOwner == true ? 
                   <div>Already a owner</div>
                    
                    : <div>Revoked</div>

                    )
                )
            
            }
            
        </div>
        </Logout> 
    )

}

// class MakeOwner extends React.Component{
//     render(){
//         return(
//             <div style={{border: '1px solid red'}}>
//                 <MuiTypography>Owner Invite Page</MuiTypography>
//                 <MuiButton >ACCEPT</MuiButton>
//             </div>
//         )
//     }
// }

export default MakeOwner

